// Telao: sem login, fonte grande, alto contraste, sem nada clicavel.
//
// Recebe tudo por SSE. A unica interacao possivel e projetar e esquecer.

import { useState } from "react";
import type { ContestStateDto, ScoreboardDto } from "@compila/shared";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api.js";
import { useContestClock, useEventStream } from "../../lib/hooks.js";
import { Scoreboard } from "../../components/Scoreboard.js";
import { ConnectionDot, Countdown, FrozenBanner, Spinner } from "../../components/ui.js";
import { CONTEST_STATUS_LABEL } from "../../lib/format.js";

export function BigScreen(): React.JSX.Element {
  const [board, setBoard] = useState<ScoreboardDto | null>(null);
  const [contest, setContest] = useState<ContestStateDto | null>(null);

  // Primeira carga por GET; a partir dai o SSE manda. Sem isso a tela ficaria
  // vazia ate o primeiro evento, que pode demorar se nada acontecer.
  const inicial = useQuery({
    queryKey: ["public-scoreboard"],
    queryFn: () => api.get<ScoreboardDto>("/public/scoreboard"),
  });

  const connection = useEventStream("/api/public/scoreboard/stream", {
    onScoreboard: setBoard,
    onContest: setContest,
  });

  const atual = board ?? inicial.data ?? null;
  const elapsed = useContestClock(contest ?? undefined);

  if (!atual) return <Spinner label="Conectando ao placar..." />;

  const congelado = contest?.frozen ?? atual.contest.frozen;

  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 border-b-4 border-slate-900 bg-white px-8 py-4">
        <div className="flex items-center gap-6">
          <h1 className="text-4xl font-black tracking-tight text-slate-900">PLACAR</h1>

          {congelado && <FrozenBanner big />}

          <div className="ml-auto flex items-center gap-6">
            <span className="text-2xl font-semibold text-slate-600">
              {CONTEST_STATUS_LABEL[contest?.status ?? atual.contest.status]}
            </span>
            <Countdown
              elapsed={contest ? elapsed : atual.contest.elapsedSeconds}
              duration={atual.contest.durationSeconds}
              status={contest?.status ?? atual.contest.status}
              size="big"
            />
            <ConnectionDot state={connection} />
          </div>
        </div>
      </header>

      <main className="px-8 py-6">
        <Scoreboard board={atual} size="big" />
      </main>
    </div>
  );
}
